import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { authFetch } from "../services/authAPI";
import Field from "../components/Field";
import Modal from "../components/Modal";
import Select from "../components/Select";

export default function VehiclesPage() {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 10;
    const [vehicles, setVehicles] = useState([]);
    const [licensePlateNumber, setLicensePlateNumber] = useState("");
    const [vin, setVin] = useState("");
    const [name, setName] = useState("");
    const [brand, setBrand] = useState("");
    const [model, setModel] = useState("");
    const [archived, setArchived] = useState(false);
    const [isOperational, setIsOperational] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [violations, setViolations] = useState([]);
    const [brands, setBrands] = useState([]);
    async function fetchVehicles() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/vehicles`);
            const data = await response.json();
            setVehicles(data);
        } catch (error) {
            // silently fail
        }
    }

    async function fetchBrands() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/vehicle_brands`);
            const data = await response.json();
            setBrands(data);
        } catch (error) {
            // silently fail
        }
    }

    async function handleCreateVehicle() {
        try {
            const response = await authFetch(`${process.env.REACT_APP_API_URL}/api/vehicles`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    licensePlateNumber: licensePlateNumber,
                    vin: vin,
                    name: name,
                    brand: brand,
                    model: model,
                    isArchived: archived,
                    isOperational: isOperational
                }),
            });
            if (!response.ok) {
                const errorData = await response.json();
                setViolations(errorData.violations ?? []);
                return;
            }
            const newVehicle = await response.json();
            setVehicles((prev) => [...prev, newVehicle]);
            setShowModal(false);
            setViolations([]);
        } catch (error) {
            // silently fail
        }
    }

    useEffect(() => {
        fetchVehicles();
        fetchBrands();
    }, []);

    const filteredVehicles = vehicles.filter(
        (vehicle) =>
            vehicle.licensePlateNumber?.toLowerCase().includes(search.toLowerCase()) ||
            vehicle.name?.toLowerCase().includes(search.toLowerCase()) ||
            vehicle.vin?.toLowerCase().includes(search.toLowerCase()),
    );

    const totalPages = Math.ceil(filteredVehicles.length / entriesPerPage);

    const paginatedVehicles = filteredVehicles.slice(
        (currentPage - 1) * entriesPerPage,
        currentPage * entriesPerPage,
    );

    const BRAND_LABELS = Object.fromEntries(
        brands.map((b) =>
            [b.value, b.label]
        )
    );

    return (
        <>
            <Modal
                title={"Ajouter un véhicule"}
                body={
                    <>
                        {violations.length > 0 && (
                            <div className="alert alert-danger d-flex align-items-center" role="alert">
                                <i className="fas fa-times-circle me-3"></i>
                                <ul className="mb-0 list-unstyled">
                                    {violations.map((v, i) => (
                                        <li key={i}>{v.message}</li>
                                    ))}
                                </ul>
                            </div>
                        )}
                        <Field
                            name="licensePlateNumber"
                            label="Plaque d'immatriculation"
                            value={licensePlateNumber}
                            onChange={(e) =>
                                setLicensePlateNumber(e.target.value)
                            }
                            type="text"
                        />
                        <Field
                            name="vin"
                            label="VIN"
                            value={vin}
                            onChange={(e) => setVin(e.target.value)}
                            type="text"
                        />
                        <Field
                            name="name"
                            label="Nom"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            type="text"
                        />
                        <Select
                            name="brand"
                            label="Marque"
                            value={brand}
                            onChange={(e) => setBrand(e.target.value)}
                            options={brands.map((b) => ({
                                value: b.value,
                                label: b.label,
                            }))}
                        />
                        <Field
                            name="model"
                            label="Modèle"
                            value={model}
                            onChange={(e) => setModel(e.target.value)}
                            type="text"
                        />
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={!archived}
                                onChange={(e) => setArchived(!e.target.checked)}
                                id="flexCheckDefault"
                            />
                            <label
                                className="form-check-label"
                                htmlFor="flexCheckDefault"
                            >
                                Visible
                            </label>
                        </div>
                        <div className="form-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                checked={isOperational}
                                onChange={(e) => setIsOperational(e.target.checked)}
                                id="flexCheckOperational"
                            />
                            <label
                                className="form-check-label"
                                htmlFor="flexCheckOperational"
                            >
                                Opérationnel
                            </label>
                        </div>
                    </>
                }
                button={{
                    close: "Annuler",
                    valid: "Créer",
                }}
                showModal={showModal}
                setShowModal={setShowModal}
                onSubmit={handleCreateVehicle}
            />
            <section>
                <div className="card mb-4">
                    <div className="card-header py-3">
                        <div className="row py-3">
                            <div className="col-sm-6 text-center text-sm-start">
                                <h5 className="mb-4 mb-sm-0 mt-2">
                                    Gestion des véhicules
                                </h5>
                            </div>

                            <div className="col-sm-6 text-center text-sm-end">
                                <button
                                    type="button"
                                    className="btn btn-primary me-2"
                                    onClick={() => { setShowModal(true); setViolations([]); }}
                                >
                                    Ajouter
                                    <i className="fas fa-plus ms-2"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="card-body py-5 px-5">
                        <div className="d-flex align-items-center mb-4">
                            <div className="flex-grow-1">
                                <Field
                                    name="search"
                                    label="Rechercher"
                                    value={search}
                                    onChange={(e) => {
                                        setSearch(e.target.value);
                                        setCurrentPage(1);
                                    }}
                                    type="text"
                                    margin={false}
                                />
                            </div>
                        </div>
                        <table className="table table-hover card-body align-middle mb-0 bg-white">
                            <thead className="bg-light">
                                <tr>
                                    <th className="text-left">Véhicule</th>
                                    <th className="text-center">Marque</th>
                                    <th className="text-center">Tickets</th>
                                    <th className="text-center">Opérationnel</th>
                                    <th className="text-center">Visible</th>
                                </tr>
                            </thead>
                            <tbody>
                                {paginatedVehicles.map((vehicle) => (
                                    <tr
                                        key={vehicle.id}
                                        onClick={() =>
                                            navigate(`/vehicles/${vehicle.id}`)
                                        }
                                        style={{ cursor: "pointer" }}
                                    >
                                        <td>
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <h6 className="fw-bold">
                                                        {vehicle.name && (
                                                            <span className="text-muted">
                                                                {vehicle.name}{" "}
                                                                ┃{" "}
                                                            </span>
                                                        )}
                                                        {vehicle.licensePlateNumber}
                                                    </h6>

                                                    <p className="text-muted mb-0">
                                                        {vehicle.vin}
                                                    </p>
                                                </div>
                                            </div>
                                        </td>
                                        <td className="text-center">
                                            <p className="fw-normal mb-0">
                                                {BRAND_LABELS[vehicle.brand] ??
                                                    vehicle.brand}{" "}
                                                {vehicle.model}
                                            </p>
                                        </td>
                                        <td className="text-center">
                                            {vehicle.totalTickets}
                                        </td>
                                        <td className="text-center">
                                            {vehicle.isOperational ? (
                                                <i className="fa-solid fa-circle-check text-success"></i>
                                            ) : (
                                                <i className="fa-solid fa-circle-xmark text-danger"></i>
                                            )}
                                        </td>
                                        <td className="text-center">
                                            {vehicle.isArchived ? (
                                                <i className="fa-solid fa-circle-xmark text-danger"></i>
                                            ) : (
                                                <i className="fa-solid fa-circle-check text-success"></i>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                        {totalPages > 1 && (
                            <nav className="d-flex justify-content-end mt-4">
                                <ul className="pagination pagination-sm mb-0">
                                    <li
                                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() =>
                                                setCurrentPage((p) => p - 1)
                                            }
                                        >
                                            <i className="fas fa-chevron-left fa-xs"></i>
                                        </button>
                                    </li>
                                    {Array.from(
                                        { length: totalPages },
                                        (_, i) => (
                                            <li
                                                key={i}
                                                className={`page-item ${currentPage === i + 1 ? "active" : ""}`}
                                            >
                                                <button
                                                    className="page-link"
                                                    onClick={() =>
                                                        setCurrentPage(i + 1)
                                                    }
                                                >
                                                    {i + 1}
                                                </button>
                                            </li>
                                        ),
                                    )}
                                    <li
                                        className={`page-item ${currentPage === totalPages ? "disabled" : ""}`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() =>
                                                setCurrentPage((p) => p + 1)
                                            }
                                        >
                                            <i className="fas fa-chevron-right fa-xs"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
}
